<template>
  <v-card flat class="rounded-xl overflow-hidden pa-8">
    <custom-tabs v-model="tabs" :tab-items="tabItems" grow>
      <template v-slot:staticItems>
        <v-tabs-items v-model="tabs">
          <!-- تب اول: فروشگاه‌های آنلاین (پویا بر اساس مارکت انتخابی) -->
          <v-tab-item>
            <component :is="settingPage" :marketplace="marketplace" :store_id="store_id" />
          </v-tab-item>

          <!-- تب دوم: کسر قیمت رقبا -->
          <v-tab-item>
            <competitor-deduction-tab :marketplace="marketplace" :store_id="store_id" />
          </v-tab-item>

          <!-- تب سوم: هزینه بسته‌بندی -->
          <v-tab-item>
            <packaging-cost-tab :marketplace="marketplace" :store_id="store_id" />
          </v-tab-item>

          <!-- تب چهارم: تخفیف فروش عمده -->
          <v-tab-item>
            <bulk-discount-tab :marketplace="marketplace" :store_id="store_id" />
          </v-tab-item>
        </v-tabs-items>
      </template>
    </custom-tabs>
  </v-card>
</template>

<script>
import CompetitorDeductionTab from "./CompetitorDeductionTab.vue";
import PackagingCostTab from "./PackagingCostTab.vue";
import OnlineStoresTab from "./OnlineStoresTab.vue";
import BulkDiscountTab from "./BulkDiscountTab.vue";
import SettingTabOther from "./settingTabOther.vue";
import SettingTabshop from "./settingTabshop.vue";

export default {
  name: "SettingsPage",
  components: {
    CompetitorDeductionTab,
    PackagingCostTab,
    OnlineStoresTab,
    BulkDiscountTab,
    SettingTabOther,
    SettingTabshop,
  },
  props: {
    marketplace: {
      type: String,
      default: "digikala",
    },
    store_id: {
      type: [Number, String],
      default: null,
    },
  },
  data: () => ({
    tabs: 0,
    tabItems: [
      { text: "تنظیمات فروشگاه‌های آنلاین", value: 0, icon: "storefront-outline" },
      { text: "کسر قیمت رقبا", value: 1, icon: "cash-minus" },
      { text: "هزینه بسته‌بندی", value: 2, icon: "package-variant" },
      { text: "تخفیف فروش عمده", value: 3, icon: "cart-percent" },
    ],
  }),
  computed: {
    settingPage() {
      const shopMarketplaces = ["digikala", "technolife", "snappshop"];
      return shopMarketplaces.includes(this.marketplace)
        ? "SettingTabshop"
        : "SettingTabOther";
    },
  },
};
</script>
